/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
let PdfViewer = React.lazy(() => import('DesignSystem/PdfViewer/react'))



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/PdfFile/Content"
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let documentPreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'document',
path: 'preview_url',
})
  return (<React.Fragment
>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<SuspenseBoundary
{...childProps}
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<PdfViewer
  viewPath={`${viewPath}/PdfViewer`}
 data="document.preview_url"
 url={documentPreviewUrlValueData}
/>
</div>
)}
</SuspenseBoundary>
)}
</SentryErrorBoundary>
{children}
</React.Fragment>)
}